<h1 class="main">
    <div class="row">
        <div class="col-sm-8 title">
            <status-indicator class="header title" [statusId]="userCycle.UserStatus"></status-indicator>
            {{ complianceItem.Title }}
        </div>
        <div class="col-sm-4">
            <div>
                <div ngbDropdown>
                    <div class="d-grid pt-0">
                        <button class="btn btn-info" ngbDropdownToggle><i *ngIf="userCycle.ActionRequired" class="fas fa-exclamation action-required" aria-hidden="true" ></i> History</button>
                    </div>
                    <div class="dropdown-menu" ngbDropdownMenu>
                        <li *ngFor="let cycle of cycleHistory.Results"  class="w-100  cycle-history-item" > 
                            <button [disabled]="cycle.CycleID == userCycle.CycleID" 
                                    [class.btn-primary]="cycle.CycleID == userCycle.CycleID" 
                                    [class.btn-info]="cycle.CycleID != userCycle.CycleID"  class="w-100 pt-2 text-start btn btn-sm" uiSref="." [uiParams]="{ cycleId: cycle?.CycleID }">
                                        <status-indicator class="header" [statusId]="cycle.UserStatus"></status-indicator>   {{ cycle.StartDate | date: 'MMMM dd, yyyy' }} - {{ cycle.EndDate | date: 'MMMM dd, yyyy' }}
                            </button>
                        </li>
                    </div>
                </div>
            </div>
        </div>
    </div>

</h1>
<div class="content">
    <div class="row">
        <div class="col-md-12 col-lg-8">
            <ul class="nav nav-tabs" *ngIf="!isPendingSubmission()">
                <li class="nav-item">
                    <button type="button" class="btn btn-link nav-link active" [class.active]="actionState === UserRequestActionState.INFORMATION" (click)="toggleActionState(UserRequestActionState.INFORMATION)">Requirements</button>
                </li>
                <li class="nav-item">
                    <button type="button" class="btn btn-link nav-link active" [class.active]="actionState === UserRequestActionState.DETAILS" (click)="toggleActionState(UserRequestActionState.DETAILS)">Details</button>
                </li>
            </ul>
            <compliance-item-cycle-requirements *ngIf="actionState === UserRequestActionState.INFORMATION"
                [complianceItem]="complianceItem"
                [userCycle]="userCycle"
                [itemPackets]="itemPackets"
                [ActionRequired]="ActionRequired">
            </compliance-item-cycle-requirements>
            <compliance-item-cycle-details *ngIf="actionState === UserRequestActionState.DETAILS"
                [complianceItem]="complianceItem"
                [userCycle]="userCycle"
                [verificationHistory]="verificationHistory"
                [evidence]="evidence"
                (completeQuestionnaire)="completeQuestionnaire($event)">
            </compliance-item-cycle-details>
        </div>
        <div class="col-md-12 col-lg-4 flex-md-first flex-lg-last push-down">
            <ul class="compliance-action-menu" *ngIf="isPendingSubmission()">
                <li><button class="btn w-100 text-start"
                            [class.btn-secondary]="complianceItem.EvidenceRequired === CplRequirement.REQUIRED"
                            [class.btn-info]="complianceItem.EvidenceRequired !== CplRequirement.REQUIRED"
                            [ngbTooltip]="complianceItem.EvidenceRequired !== CplRequirement.REQUIRED ? 'Not Required' : null"
                            *ngIf="(userCycle.HasAttachments || complianceItem.EvidenceRequired !== CplRequirement.NONE) 
                                && userCycle.VerifiedStatus === CycleVerificationActions.NOACTION 
                                && !Archived "
                            (click)="uploadEvidence()">Upload Evidence <i class="fas float-end"
                                                                            [class.fa-check]="userCycle.HasAttachments"
                                                                            [class.fa-exclamation]="complianceItem.EvidenceRequired === CplRequirement.REQUIRED && !userCycle.HasAttachments"></i></button></li>
                <li *ngIf="complianceItem.QfmID !== '' ">
                    <button class="btn w-100 text-start"
                            *ngIf="userCycle.VerifiedStatus === CycleVerificationActions.NOACTION && !Archived"
                            [class.btn-secondary]="complianceItem.QfmRequired"
                            [class.btn-info]="!complianceItem.QfmRequired"
                            [ngbTooltip]="!complianceItem.QfmRequired ? 'Not Required' : null"
                            (click)="completeQuestionnaire(userCycle.QfmID)">Complete Questionnaire <i class="fas float-end"
                                                                                                        [class.fa-check]="userCycle.HasCompletedQuestionnaire"
                                                                                                        [class.fa-exclamation]="complianceItem.QfmRequired && !userCycle.HasCompletedQuestionnaire"></i></button>
                </li>
                <li><button class="btn btn-success w-100 text-start"
                            *ngIf="userCycle.VerifiedStatus === CycleVerificationActions.NOACTION && !Archived "
                            (click)="submitForVerification()"
                            [disabled]="!complianceItemHelpersService.isItemReadyToSubmit(userCycle, complianceItem)">
                                Submit for Approval <i class="fas float-end"
                                                        [class.fa-check]="userCycle.VerifiedStatus > 0"
                                                        [class.fa-exclamation]="(complianceItem.EvidenceRequired === CplRequirement.REQUIRED && !userCycle.HasAttachments ) && (complianceItem.QfmRequired && !userCycle.HasCompletedQuestionnaire)"></i>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</div>